import { cn } from "@omni/utils/styles";

import { Anchor } from "@/components/General/Anchor/anchor.component";
import { useProductComparisonBarContext } from "@/components/Product/ProductComparisonBar/context/productComparisonBar.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { Config } from "@/utils/config.utils";

type Props = {
    className?: string;
};

export const CompareButton = ({ className }: Props) => {
    const { t } = useGranite();

    const { products } = useProductComparisonBarContext();

    const skus = products.map((product) => product.sku);

    const href = `${Config.pages.compare}?products=${skus.join(",")}`;

    return (
        <div className={cn("tw:w-full tw:px-4 tw:pb-4")}>
            <Anchor
                href={href}
                className={className}
                fullWidth={true}
            >
                {t("productComparison.compareProducts", products.length)}
            </Anchor>
        </div>
    );
};
